<template>
    <div class="container">
        <div class="box">
            <img class="img" :src="img" alt="map" />
            <h3 class="title reveal-bottom">
                <p>{{ $t("h.c4t1") }}</p>
                <p>{{ $t("h.c4t2") }}</p>
            </h3>
            <p class="line reveal-bottom">HD/DC</p>
            <p class="line1 reveal-bottom">Branch Office</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "content3",
    data() {
        return {
            img: require("@/assets/images/Bitmap.png"),
        };
    },
};
</script>
<style scoped>
.container {
    background-color: #00a3d1;
    overflow: hidden;
}
.box {
    width: 1200px;
    margin: auto;
    position: relative;
}
.img {
    width: 686px;
    height: 646px;
    float: right;
    margin-top: 120px;
    margin-bottom: 120px;
}
.title {
    width: 450px;
    position: absolute;
    top: 212px;
}
.title > p {
    font-size: 28px;
    color: #ffffff;
    font-weight: bold;
    font-size: 22px;
    line-height: 46px;
}
.line {
    width: 909px;
    position: absolute;
    top: 430px;
    font-size: 24px;
    color: #ffffff;
}
.line::before {
    content: "";
    width: 100%;
    height: 1px;
    background-color: #fff;
    position: absolute;
    bottom: -17px;
}
.line1 {
    width: 662px;
    position: absolute;
    top: 520px;
    font-size: 24px;
    color: #ffffff;
}
.line1::before {
    content: "";
    width: 100%;
    height: 1px;
    background-color: #fff;
    position: absolute;
    bottom: -17px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Home/Content3.vue